// const BASEURL = 'http://192.168.2.186/api/v1';
// const BASEURL = 'https://api-dreamus-testing.ecoopzone.com/api/v1';
const BASEURL = 'https://api-dreamus.ecoopzone.com/api/v1';
// const BASEURL = 'http://localhost/api/v1';

const VERIFICATION = {
    API_VERIFICATION: `${BASEURL}/verification`,
};

const WAIVER = {
    API_WAIVER: `${BASEURL}/waiver`,
};

const CUSTOMER = {
    API_CUSTOMER: `${BASEURL}/customer`,
};

const AUTH = {
    API_AUTH: `${BASEURL}/member/auth`,
};

const ONLINE_SALES = {
    API_CHECKOUT_PRODUCT_AVAILABILITY: `${BASEURL}/checkout/ticketing/product-availability`,
    API_CHECKOUT_DAYS_AVAILABILITY: `${BASEURL}/checkout/ticketing/availability`,
    API_CREATE_PAYMENT: `${BASEURL}/checkout/ticketing/order`,
    API_CREATE_PAYMENT_PARTY: `${BASEURL}/checkout/ticketing/order-party`,
    API_CREATE_PAYMENT_SUBSCRIPTION: `${BASEURL}/checkout/ticketing/order-subscription`,
    API_CHECK_PAYMENT_SUBSCRIPTION: `${BASEURL}/checkout/ticketing/check/order-subscription`,
    API_GET_BRANDS: `${BASEURL}/master/brands`,
    API_GET_OUTLETS: `${BASEURL}/master/outlets`,
    API_GET_ONLINE_SALES_PARTY_AVAILABILITY_LIST: `${BASEURL}/checkout/ticketing/check/availability-capacity`,
};

const GETORDERBYID = {
    API_ORDER: `${BASEURL}/checkout/ticketing/order`,
};

const USER = {
    API_USER_PROFILE: `${BASEURL}/member/profile`,
    API_USER_CREDIT: `${BASEURL}/member/credit`,
    API_USER_POINTS: `${BASEURL}/member/points`,
    API_USER_VOUCHERS: `${BASEURL}/member/vouchers`,
    API_USER_COUPONS: `${BASEURL}/member/coupons`,
    API_USER_ORDERS: `${BASEURL}/member/orders`,
    API_USER_HISTORY_TRX: `${BASEURL}/member/transactions`,
    API_USER_HISTORY_TRX_DETAIL: `${BASEURL}/member/transaction`,
    API_USER_WAIVER_UPDATE: `${BASEURL}/member/waiver/update`,
    API_USER_WAIVER_UPDATE_PHONE: `${BASEURL}/member/waiver/phone-update`,
    API_USER_WAIVER_UPDATE_EMAIL: `${BASEURL}/member/waiver/email-update`,
    API_USER_WAIVER_CREATE_CHILD: `${BASEURL}/member/children/create`,
    API_USER_WAIVER_UPDATE_CHILD: `${BASEURL}/member/children/update`,
    API_USER_WAIVER_DELETE_CHILD: `${BASEURL}/member/children/delete`,
    API_USER_LOYALTY_TIER: `${BASEURL}/member/loyalty-tier`,
    API_USER_AVAILABLE_REWARDS: `${BASEURL}/member/available-rewards`,
    API_USER_POINT_HISTORY: `${BASEURL}/member/point-history`,
    API_USER_REDEEM_HISTORY: `${BASEURL}/member/redeem-history`,
    API_USER_TRIGGER_REDEEM: `${BASEURL}/member/trigger-redeem`,
};

export { AUTH, CUSTOMER, GETORDERBYID, ONLINE_SALES, USER, VERIFICATION, WAIVER };

